module.exports = __webpack_public_path__ + "static/media/campaignLinked.4f408a6e.png";